/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_TimecodeInputs */



/**
* | output |
* | --- |
* | "New timecode" |
*
* @param {New_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_timecode = /** @type {((inputs?: New_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Timecode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый таймкод")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo código de tempo")
	return /** @type {LocalizedString} */ ("New timecode")
});